import {
  FormControl,
  Input,
  InputGroup,
  Text,
  useToast,
  useDisclosure,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  ModalFooter,
  ModalHeader,
  Button,
  RadioGroup,
  Radio,
  Stack,
  Checkbox,
} from "@chakra-ui/react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { api } from "../../Api/ApiService";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import Alert from "sweetalert2";

interface IInputsUpdateTutor {
  tutor_id: string;
  experiencia_com_animais: boolean;
  possui_outros_animais: boolean;
  possui_gato: boolean;
  possui_cachorro: boolean;
  outros_animais: Array<string>[];
  quantidade_animais: number;
  infor_id?: string;
}

type entrada = {
  tutor_id: string;
  cadastroUser?: string;
  onClose: () => void;
  isOpen: boolean;
};

export const ModalInforComp = ({
  tutor_id,
  cadastroUser,
  onClose,
  isOpen,
}: entrada) => {
  // const { isOpen, onOpen, onClose } = useDisclosure();
  const [isModal, setIsmodal] = useState(true);
  const [expeValue, setExpeValue] = useState("");
  const [outrosPetsValue, setOutrosPetsValue] = useState("");
  const navigator = useNavigate();
  const {
    register: registerUpdateTutor,
    handleSubmit: handleSubmitUpdateTutor,
  } = useForm<IInputsUpdateTutor>();
  const toast = useToast();

  async function onSubmitForm(data: IInputsUpdateTutor) {
    try {
      const infor_found = await api.get(
        `/informacoes_complementares?token=${process.env.REACT_APP_TOKEN_API}`,
        {
          params: {
            id_tutor: tutor_id,
          },
        }
      );

      if (infor_found.data.data) {
        const atualiza = await api.patch(
          `/informacoes_complementares?token=${process.env.REACT_APP_TOKEN_API}`,
          {
            infor_id: infor_found.data.data.informacoes_comp_id,
            experiencia_com_animais: expeValue === "1" ? true : false,
            possui_outros_animais: outrosPetsValue === "1" ? true : false,
            possui_gato: data.possui_gato,
            possui_cachorro: data.possui_cachorro,
            outros_animais: data.outros_animais,
            quantidade_animais: Number(data.quantidade_animais),
          },
          {
            params: {
              id_tutor: tutor_id,
            },
          }
        );
        onClose();

        Alert.fire({
          toast: true,
          icon: "success",
          text: atualiza.data.message,
          confirmButtonText: "OK",
          confirmButtonColor: "#3f3d56",
        }).then(() => {
          window.location.reload();
        });
      } else {
        const result = await api.post(
          `/informacoes_complementares?token=${process.env.REACT_APP_TOKEN_API}`,
          {
            tutor_id: tutor_id,
            experiencia_com_animais: expeValue === "1" ? true : false,
            possui_outros_animais: outrosPetsValue === "1" ? true : false,
            possui_gato: data.possui_gato,
            possui_cachorro: data.possui_cachorro,
            outros_animais: data.outros_animais,
            quantidade_animais: Number(data.quantidade_animais),
          }
        );
        onClose();
        cadastroUser === "cadastroUser" ? navigator("/") : <></>;

        Alert.fire({
          toast: true,
          icon: "success",
          text: result.data.message,
          confirmButtonText: "OK",
          confirmButtonColor: "#3f3d56",
        }).then(() => {
          window.location.reload();
        });
      }
    } catch (error: AxiosError | any) {
      console.log(error);
      toast({
        title: "Erro",
        description: error.response.data,
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }

  return (
    <form>
      <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            display={"flex"}
            justifyContent={"center"}
            color={"#3F3D56"}
            fontWeight={"bold"}
            fontSize={25}
          >
            Complemente as informações
          </ModalHeader>
          <ModalBody>
            <FormControl
              display={"flex"}
              flexDir={"row"}
              gap={10}
              justifyContent={"space-between"}
            >
              <Text>Tem experiência com animais?</Text>
              <RadioGroup
                onChange={setExpeValue}
                value={expeValue}
                display={"flex"}
                gap={3}
              >
                <Radio value={"1"}>Sim</Radio>
                <Radio value={"2"}>Não</Radio>
              </RadioGroup>
            </FormControl>
            <FormControl
              display={"flex"}
              flexDir={"row"}
              gap={10}
              justifyContent={"space-between"}
            >
              <Text>Tem outros animais em casa?</Text>
              <RadioGroup
                onChange={setOutrosPetsValue}
                value={outrosPetsValue}
                display={"flex"}
                gap={3}
              >
                <Radio value={"1"}>Sim</Radio>
                <Radio value={"2"}>Não</Radio>
              </RadioGroup>
            </FormControl>

            {outrosPetsValue === "1" ? (
              <>
                {/* <Text marginTop={3} marginBottom={3}>Se respondeu sim para a pergunta anterior, responda a seguir:</Text> */}
                <Stack direction={"row"} marginTop={7}>
                  <Checkbox {...registerUpdateTutor("possui_gato")}>
                    Gato
                  </Checkbox>
                  <Checkbox {...registerUpdateTutor("possui_cachorro")}>
                    Cachorro
                  </Checkbox>
                  <Checkbox> Outros </Checkbox>
                  <Input
                    type="text"
                    w={150}
                    h={8}
                    fontSize={15}
                    variant={"filled"}
                    border={"1px solid #B0BEC5"}
                    {...registerUpdateTutor("outros_animais")}
                  />
                </Stack>
                <FormControl
                  display={"flex"}
                  flexDir={"row"}
                  marginTop={2}
                  marginBottom={2}
                >
                  <Text>Quantidade de animais em casa:</Text>
                  <Input
                    type="number"
                    w={150}
                    h={8}
                    fontSize={15}
                    marginLeft={3.5}
                    variant={"filled"}
                    border={"1px solid #B0BEC5"}
                    {...registerUpdateTutor("quantidade_animais")}
                  />
                </FormControl>
              </>
            ) : null}
          </ModalBody>
          <ModalFooter>
            <InputGroup gap={8} display={"contents"}>
              <Button
                w={40}
                h={8}
                border={"1px solid #c03333"}
                color={"#c03333"}
                fontWeight={"medium"}
                marginRight={"5"}
                backgroundColor={"white"}
                onClick={() => {
                  // setIsmodal(false);
                  onClose();
                  cadastroUser === "cadastroUser" ? navigator("/") : <></>;
                }}
              >
                Fechar
              </Button>
              <Button
                type="submit"
                w={40}
                h={8}
                border={"1px solid #044549"}
                color={"#044549"}
                fontWeight={"medium"}
                onClick={handleSubmitUpdateTutor(onSubmitForm)}
              >
                Salvar
              </Button>
            </InputGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </form>
  );
};
